import { jsx as n } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { c as t } from "../../index-Cu0xwYjD.js";
import { idsLogger as m } from "../../utils/helpers.js";
const a = "ids-skip-link-v501", f = {
  skipLink: a
}, l = e(
  ({
    targetId: i,
    href: s,
    children: o = "Skip to content",
    className: r,
    ...p
  }, k) => !i && !s ? (m(
    "SkipLink: You must define other a targetId or href prop to display a skip link."
  ), null) : /* @__PURE__ */ n(
    "a",
    {
      ...p,
      className: t(r, f.skipLink),
      href: i ? `#${i}` : s,
      ref: k,
      children: o
    }
  )
);
l.displayName = "IressSkipLink";
export {
  l as IressSkipLink
};
